import { reactive, toRefs, watch } from 'vue'

const cloneList = (list) => JSON.parse(JSON.stringify(list || []))

export function useFilterDialogState(props) {
  const state = reactive({
    plan: {
      mediaIds: [],
      adAccountIdList: [],
      designerIds: [],
      planName: ''
    },
    image: {
      gameGroupIds: [],
      gameIds: [],
      designerIds: [],
      imageName: ''
    },
    pageSize: 10,
    pageIndex: 1,
    tableData: [],
    total: 0,
    result: [],
    textArr: [],
    loading: false,
    disabled: false
  })

  const getSelected = () => {
    state.pageIndex = 1
    state.result = props.title === '计划选择' ? cloneList(props.backPlan) : cloneList(props.backImage)
  }

  watch(
    () => props.title,
    () => {
      getSelected()
    }
  )

  watch(
    () => props.backPlan,
    () => {
      getSelected()
    },
    { immediate: true }
  )

  watch(
    () => props.backImage,
    () => {
      getSelected()
    },
    { immediate: true }
  )

  return {
    ...toRefs(state),
    getSelected
  }
}
